import { FileConversionStatus } from './FileConversionStatus'
import { FileType } from './FileType'
import { FileVersion } from './FileVersion'
import { OriginalFile } from './OriginalFile'

export class UserFile {
    userFileId!: string
    convertedFileName!: string
    originalFile?: OriginalFile
    created?: Date
    fileType!: FileType
    fileVersions!: FileVersion[]
    status!: FileConversionStatus
    isAvailable?: boolean
    hasMissingVersions?: boolean
}